import { render, staticRenderFns } from "./EmployeesLeaves.vue?vue&type=template&id=3b104357&"
import script from "./EmployeesLeaves.vue?vue&type=script&lang=ts&"
export * from "./EmployeesLeaves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports